import { useState } from "react";
import useRegistration from "../hooks/useRegistration";
import { toast } from 'react-toastify';

const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  gender: "",
  address: "",
  course: "",
};

const RegistrationForm = () => {


  const [state, setState] = useState(initialState);

  const { addRegistartion, isRegistering } = useRegistration();


  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };


  const clearState = () => setState({ ...initialState });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const response = await addRegistartion(state);
      clearState();


      return toast.success(response?.data?.message || "Success")

    } catch (error) {
      console.error("Error while Registration:", error);
      toast.error(error?.response?.data?.message || error?.response?.data?.error || "Something went wrong")
    }
  }
  // const container = {
  //   display: "flex",
  //   width: "100%",
  //   minHeight: "100vh",
  //   backgroundColor: "#2f2a2a",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   padding: "20px",
  //   boxSizing: "border-box",
  // };

  const box = {
    display: "flex",
    width: "100%",
    // maxWidth: "900px",
    backgroundColor: "#fff",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 0 10px rgba(0,0,0,0.2)",
  };

  const imageBox = {
    width: "50%",
    height: "100%",
  };

  const image = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  };

  const formBox = {
    width: "50%",
    padding: "40px",
    boxSizing: "border-box",
  };

  const heading = {
    fontSize: "20px",
    fontWeight: "bold",
    marginBottom: "20px",
  };

  const inputRow = {
    display: "flex",
    gap: "10px",
    marginBottom: "15px",
  };

  const input = {
    flex: 1,
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  };

  const fullInput = {
    width: "100%",
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    marginBottom: "15px",
  };

  const genderRow = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "15px",
  };

  const buttonRow = {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
  };

  const resetBtn = {
    padding: "10px 20px",
    borderRadius: "5px",
    backgroundColor: "#fff",
    border: "1px solid #999",
    cursor: "pointer",
  };

  const submitBtn = {
    padding: "10px 20px",
    borderRadius: "5px",
    backgroundColor: "#fbbf24",
    color: "#fff",
    border: "none",
    cursor: "pointer",
  };

  const submitBtnDisabled = {
    padding: "10px 20px",
    borderRadius: "5px",
    backgroundColor: "#d1d5db",
    color: "#6b7280",
    border: "none",
    cursor: "not-allowed",
    opacity: 0.6,
  };



  return (
    <div id="form" className="text-center">

      <div className="container">
        <div className="section-title">
          <h2>Registration</h2>
        </div>
        <div style={box}>
          <div style={imageBox}>
            <img
              src="https://images.pexels.com/photos/3184300/pexels-photo-3184300.jpeg"
              alt="students"
              style={image}
            />
          </div>
          <div style={formBox}>
            <div style={heading}>STUDENT REGISTRATION FORM</div>
            <form onSubmit={handleSubmit}>
              <div style={inputRow}>
                <input type="text" placeholder="First name" style={input} id="firstName" name="firstName" required onChange={handleChange} value={state.firstName} />
                <input type="text" placeholder="Last name" style={input} id="lastName" name="lastName" required onChange={handleChange} value={state.lastName} />
              </div>
              <input type="email" placeholder="Email" style={fullInput} id="email" name="email" required onChange={handleChange} value={state.email} />

              <div style={genderRow}>
                <label><b>Gender:</b></label>
                <label><input type="radio" name="gender" id="gender" onChange={handleChange} value="female" required checked={state.gender === "female"} /> Female</label>
                <label><input type="radio" name="gender" id="gender" onChange={handleChange} value="male" checked={state.gender === "male"} /> Male</label>
                <label><input type="radio" name="gender" id="gender" onChange={handleChange} value="other" checked={state.gender === "other"} /> Other</label>
              </div>
              <div style={inputRow}>
                {/* <select style={input}><option>State</option></select> */}
                {/* <select style={input}><option>City</option></select> */}
              </div>
              <input type="text" placeholder="Address" style={fullInput} id="address" name="address" required onChange={handleChange} value={state.address} />
              {/* <input type="text" placeholder="Pincode" style={fullInput} /> */}
              <input type="text" placeholder="Course" style={fullInput} id="course" name="course" required onChange={handleChange} value={state.course} />

              <div style={buttonRow}>
                <button type="reset" style={resetBtn} >RESET ALL</button>
                <button type="submit" style={isRegistering ? submitBtnDisabled : submitBtn} disabled={isRegistering}>SUBMIT FORM</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationForm;
